"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataFilterComponent = void 0;
const core_1 = require("@angular/core");
const bid_data_filter_service_1 = require("./bid-data-filter.service");
const events_1 = require("./events");
const boolean_key_pipe_1 = require("./boolean-key.pipe");
const search_custom_pipe_1 = require("./search-custom.pipe");
const data_source_service_1 = require("./data-source.service");
let DataFilterComponent = class DataFilterComponent {
    constructor(_dataSource, _bidDataFilter, _booleanKey, _searchCustom) {
        this._dataSource = _dataSource;
        this._bidDataFilter = _bidDataFilter;
        this._booleanKey = _booleanKey;
        this._searchCustom = _searchCustom;
        this.fuzzySearch = false;
        this.filterName = '';
        this.filterData = [];
        this.groupByFilter = false;
        this.groupByName = '';
        this.dataSource = 'biddr';
        this.onFilterSelected = new core_1.EventEmitter();
        this.filterSearch = '';
        this.pullingFilterData = false;
        this.pullingFilterDataResolved = false;
        this.customMappingData = [];
        this.showCustomGroupMapping = false;
        this.reachedPageDataLimit = false;
        this.dataLoadingFailed = false;
        this.MAX_DATA_PER_PAGE = 100;
        this.totalSelected = 0;
        this.maxSelectableFilters = 300;
        this.reachedMaxSelectable = false;
        this.totalSearchedFoundFilters = undefined;
    }
    ngOnInit() {
        this.totalSelected = this._bidDataFilter.getTotalSelectedFilterOptions(this.groupByName, this.dataSource);
        this.loadLocalFilterData();
        this.maxSelectableFilters = this._bidDataFilter.MAX_SELECTABLE_FILTERS;
    }
    onMenuContainerScroll(event) {
        const target = event.target;
        const limit = target.scrollHeight - target.clientHeight;
        if (!this.shouldDoLocalValuesSearch() && this.isTargetContainerLimit(target.scrollTop, limit)) { // if we reached the end of container
            this.loadNextPageData();
        }
    }
    isTargetContainerLimit(target, limit) {
        return (Math.ceil(target) >= parseInt(limit) || parseInt(target) >= parseInt(limit));
    }
    valueSearchChanged(searchValue) {
        return __awaiter(this, void 0, void 0, function* () {
            this.filterSearch = searchValue;
            if (this.shouldDoLocalValuesSearch()) {
                // Only apply search on the current local loaded values
                const localLoadedData = this._bidDataFilter.getFilterLocalDataValues(this.groupByName, this.dataSource) || [];
                this.filterData = this._searchCustom.transform(localLoadedData, searchValue, ['displayName']);
                this.totalSearchedFoundFilters = this.filterData.length;
            }
            else if (searchValue) {
                const { data, totalCount } = yield this.getFilterData({ value: searchValue, limit: 300, fuzzy: this.fuzzySearch });
                this.totalSearchedFoundFilters = totalCount;
                if (data && data.length) {
                    // load the new searched data;
                    this.loadLocalFilterData(this._bidDataFilter.parseFilterData({
                        filterSlug: this.groupByName,
                        filterSource: this.dataSource,
                        filterData: data
                    }));
                }
            }
            else {
                // reset to show default loaded filter data;
                this.loadLocalFilterData();
            }
        });
    }
    stopAutoclose(event) {
        event.stopPropagation();
    }
    onFilterDropdownBtnCLick() {
        if (!this._bidDataFilter.hasFilterData(this.groupByName, this.dataSource)) {
            // load the initial page data;
            this.loadFilterPageData(1);
        }
    }
    loadFilterPageData() {
        return __awaiter(this, arguments, void 0, function* (dataPage = 1) {
            if (!this.reachedPageDataLimit) {
                const { data, totalCount } = yield this.getFilterData({ page: dataPage, limit: this.MAX_DATA_PER_PAGE });
                if (data && data.length) {
                    this._bidDataFilter.addFilterLocalData(this.groupByName, this.dataSource, data);
                    this._bidDataFilter.setFilterCurrentPage(this.groupByName, this.dataSource, dataPage);
                    this.reachedPageDataLimit = totalCount < this.MAX_DATA_PER_PAGE;
                    this.loadLocalFilterData();
                }
            }
        });
    }
    loadNextPageData() {
        if (!this.filterSearch && !this.reachedPageDataLimit && !this.pullingFilterData) {
            const currentPage = this._bidDataFilter.getFilterCurrentPage(this.groupByName, this.dataSource);
            this.loadFilterPageData(currentPage + 1);
        }
    }
    getFilterData(options) {
        return __awaiter(this, void 0, void 0, function* () {
            this.pullingFilterDataResolved = this.pullingFilterDataResolved && options.page === 1;
            try {
                setTimeout(() => {
                    if (!this.pullingFilterDataResolved) {
                        this.pullingFilterData = true;
                        this.pullingFilterDataResolved = false;
                    }
                }, 500);
                this.dataLoadingFailed = false;
                const searchOpts = Object.assign({ limit: 100 }, options || {});
                const newData = yield this._bidDataFilter.pullNewFilterData(this._bidDataFilter.getFilterValueKey(this.groupByName), this.dataSource, searchOpts);
                this.pullingFilterData = false;
                this.pullingFilterDataResolved = true;
                return newData;
            }
            catch (err) {
                this.pullingFilterData = false;
                this.pullingFilterDataResolved = true;
                this.dataLoadingFailed = true;
                // auto close after 5 seconds
                setTimeout(() => {
                    this.dataLoadingFailed = false;
                }, 5000);
            }
        });
    }
    selectFilter(container, optionIdx, toggleTo) {
        const filterOption = container[optionIdx];
        if (!this.pullingFilterData && filterOption && filterOption.selected !== undefined) {
            // if we have search data in progress; verify the selected option it's exists in local filter data
            if (this.filterSearch && !this._bidDataFilter.hasFilterDataOpt(this.groupByName, this.dataSource, { key: 'guid', value: filterOption.guid })) {
                this._bidDataFilter.addFilterLocalData(this.groupByName, this.dataSource, [filterOption]);
            }
            const updated = this._bidDataFilter.setMenuOption(this.groupByName, this.dataSource, filterOption, toggleTo);
            // update the local container state to reflect the updated state on service
            if (container[optionIdx] && updated) {
                container[optionIdx].selected = updated.selected;
            }
            this.totalSelected = this._bidDataFilter.getTotalSelectedFilterOptions(this.groupByName, this.dataSource);
            this.reachedMaxSelectable = this._bidDataFilter.reachedMaxFilterSelection(this.groupByName, this.dataSource);
        }
        this.onFilterSelected.emit(this.filterName);
    }
    loadLocalFilterData(newFilterData) {
        if (!newFilterData && this._bidDataFilter.hasFilterData(this.groupByName, this.dataSource)) {
            newFilterData = this._bidDataFilter.getFilterLocalDataValues(this.groupByName, this.dataSource);
        }
        if (newFilterData) {
            this.filterData = newFilterData;
            // console.log('loading local data' + this.groupByName, this.filterData, this._bidDataFilter.filterBySelectedValues(this.filterData).length)
            if (this.customDataMapping && this.filterData.length)
                this.loadCustomMappingData(this.filterData);
        }
    }
    selectCustomMenuOptions(menuOptionArray) {
        const len = (this._booleanKey.transform(menuOptionArray, true, 'selected')).length;
        const selectAll = !(len === menuOptionArray.length);
        this.toggleMenuOptions(menuOptionArray, selectAll);
    }
    toggleMenuOptions(menuOptionArray, toggleTo = false) {
        const opts = menuOptionArray || [];
        // Do not process If we are selection All options and we reached max selectables;
        if (toggleTo && this._bidDataFilter.reachedMaxFilterSelection(this.groupByName, this.dataSource)) {
            this.reachedMaxSelectable = this._bidDataFilter.reachedMaxFilterSelection(this.groupByName, this.dataSource);
            return;
        }
        for (let optionIdx = 0; optionIdx < opts.length; optionIdx++) {
            this.selectFilter(menuOptionArray, optionIdx, toggleTo);
        }
    }
    switchGroupBy() {
        this._bidDataFilter.setGroupBy(this.groupByName);
        let enabled = this.groupByFilter[this.groupByName];
        this.events.add({
            subFeature: events_1.EventSubFeature.filter,
            context: this.groupByName,
            subject: this.groupByName,
            action: enabled ? events_1.EventAction.enabled : events_1.EventAction.disabled
        });
    }
    toggleGroupingToShow() {
        this.showCustomGroupMapping = !this.showCustomGroupMapping;
        const filter = "grouping-to-show";
        this.events.add({
            subFeature: events_1.EventSubFeature.filter,
            context: filter,
            action: events_1.EventAction.toggled,
            subject: this.showCustomGroupMapping ? this.customDataMapping.dataKey : this.groupByName
        });
    }
    customMappingKeyName() {
        if (this.customDataMapping && this.customDataMapping.dataKey) {
            const key = this.customDataMapping.dataKey;
            const name = key[0].toUpperCase() + key.slice(1, key.length);
            return name;
        }
        return 'Custom Mapping';
    }
    loadCustomMappingData(newFilterData) {
        if (this.canGetCustomMappingData()) {
            // load the new mapping data from the custom mapping method
            this.customMappingData = this._bidDataFilter[this.customDataMapping.dataMethod](newFilterData);
        }
        return this.customMappingData;
    }
    canGetCustomMappingData() {
        return (this.customDataMapping
            && this.customDataMapping.dataMethod
            && this._bidDataFilter[this.customDataMapping.dataMethod]);
    }
    customMappingDataCollapse() {
        for (var i = 0; i < this.customMappingData.length; i++) {
            this.customMappingData[i].collapsed = true;
        }
    }
    customMappingDataExpand() {
        for (var i = 0; i < this.customMappingData.length; i++) {
            this.customMappingData[i].collapsed = false;
        }
    }
    getCustomMappingMenuClass(menu) {
        const groupBy = this.customDataMapping.groupBy;
        const totalSelectedOpts = this._booleanKey.transform(menu[groupBy], true, 'selected').length;
        if (totalSelectedOpts === 0)
            return 'fa-circle-o';
        else if (totalSelectedOpts > 0 && totalSelectedOpts < menu[groupBy].length)
            return 'fa-dot-circle-o';
        else if (totalSelectedOpts === menu[groupBy].length)
            return 'fa-circle';
        else
            return '';
    }
    showLoadMoreDataBtn() {
        return (!this.filterSearch
            && !this.reachedPageDataLimit
            && !this.pullingFilterData
            && !this.dataLoadingFailed
            && this.filterData.length
            && this.filterData.length < 10);
    }
    shouldDoLocalValuesSearch() {
        return this.groupByName === this._bidDataFilter.FILTERS_KEYS.ORGANIZATION || this.groupByName === this._bidDataFilter.FILTERS_KEYS.DEAL_TYPE;
    }
};
exports.DataFilterComponent = DataFilterComponent;
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Boolean)
], DataFilterComponent.prototype, "fuzzySearch", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], DataFilterComponent.prototype, "filterName", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], DataFilterComponent.prototype, "filterData", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], DataFilterComponent.prototype, "groupByFilter", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], DataFilterComponent.prototype, "groupByName", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", events_1.DashboardEvents)
], DataFilterComponent.prototype, "events", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], DataFilterComponent.prototype, "dataSource", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], DataFilterComponent.prototype, "customDataMapping", void 0);
__decorate([
    (0, core_1.Output)(),
    __metadata("design:type", core_1.EventEmitter)
], DataFilterComponent.prototype, "onFilterSelected", void 0);
exports.DataFilterComponent = DataFilterComponent = __decorate([
    (0, core_1.Component)({
        selector: 'myDataFilter',
        templateUrl: 'app/data-filter.component.html',
        styleUrls: ['styles/less/data-filter.component.less']
    }),
    __metadata("design:paramtypes", [data_source_service_1.DataSourceService,
        bid_data_filter_service_1.BidDataFilterService,
        boolean_key_pipe_1.BooleanKeyPipe,
        search_custom_pipe_1.SearchCustomPipe])
], DataFilterComponent);
//# sourceMappingURL=data-filter.component.js.map